import { render, staticRenderFns } from "./Sinus.vue?vue&type=template&id=661c5e57&"
import script from "./Sinus.vue?vue&type=script&lang=js&"
export * from "./Sinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports